import React from 'react';
import AnimatedSection from '../ui/AnimatedSection';
import '../../styles/components/SectionTitle.css';

interface SectionTitleProps {
  title: string;
  subtitle: string;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title, subtitle }) => {
  return (
    <AnimatedSection className="section-title">
      <h2 className="section-title__heading">{title}</h2>
      <p className="section-title__subtitle">{subtitle}</p>
      <div className="section-title__divider" />
    </AnimatedSection>
  );
};

export default SectionTitle;
